module.exports = __webpack_public_path__ + "img/ag-hill-aerial.083725e8.jpg";